import { HelmetDexteel } from "@dexteel/mesf-core";
import { useParams } from "react-router-dom";
import { TableSection } from "./components/TableSection";

export const SectionPage = () => {
	const { sectionId } = useParams();

	return (
		<>
			<HelmetDexteel title="Sections" />
			<TableSection sectionId={sectionId} />
		</>
	);
};
